import ITestRepository from '../../2_domain/test/iTestRepository';
import {
  // DefaultPagination,
  Test,
  TestCategory,
  TestContext,
  TestCountResult,
  testFromDto,
  TestItemSummary,
  TestStatusDto,
  TestSummary,
  testSummaryFromDto,
} from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import { toKRString } from '../../lib/util/dateFormatter';
import Connection from '../core/connection';
import Connection2 from '../core/connection2';
import { CANCEL_TEST } from './testQuery';

class TestRepository implements ITestRepository {
  // LINK - id 59, NOTE - Done
  getTestStatuses = async (): Promise<TestStatusDto[]> => {
    const res = await Connection2.requestGet('clinic/pass/queryTestStatuses');
    const ret: TestStatusDto[] = [];
    for (const str in res) {
      if (res.hasOwnProperty(str)) {
        if (res[str].status === 'ORDER_COMPLETED') {
          ret.push({
            status: 'ORDER_COMPLETED',
            label: 'ORDER COMPLETED',
            context: TestContext.READY,
          });
        } else if (res[str].status === 'TEST_PROCESSING') {
          ret.push({
            status: 'ORDER_COMPLETED',
            label: 'TEST PROCESSING',
            context: TestContext.ACTIVE,
          });
        } else if (res[str].status === 'TEST_COMPLETED') {
          ret.push({
            status: 'TEST_COMPLETED',
            label: 'TEST COMPLETED',
            context: TestContext.DONE,
          });
        } else if (res[str].status === 'CANCELLATION') {
          ret.push({
            status: 'CANCELLATION',
            label: 'CANCELLATION',
            context: TestContext.ABORT,
          });
        }
      }
    }
    return ret;
  };

  //LINK - id 68
  async getTestItemDetailById(testItemCode: Serial): Promise<TestItemSummary> {
    let newData;
    const { code, ...res } = await Connection2.requestPost(
      'clinic/pass/queryTestItemById',
      {
        code: testItemCode,
      }
    );
    if (res.list?.length > 1) {
      newData = res.list[0];
    } else {
      newData = res;
    }
    return newData;
  }

  // LINK - id 57
  // NOTE - DONE
  getTestCategories = async () => {
    const res = await Connection2.requestGet('clinic/pass/queryTestCategories');
    const ret: TestCategory[] = [];
    for (const str in res) {
      if (res[str].label) {
        ret.push({
          category: res[str].category,
          label: res[str].label,
        });
      }
    }
    return ret;
  };

  // LINK - id 66
  //NOTE - pagination
  getTestSummaries = async (param: {
    status: TestStatus | 'all';
    pagination: Pagination;
    searchText?: string;
    fromDate?: Date;
    endDate?: Date;
  }): Promise<PageResult<TestSummary>> => {
    let dateRange: { begin: string; end: string } | undefined;
    if (param.fromDate && param.endDate) {
      dateRange = {
        begin: toKRString(param.fromDate),
        end: toKRString(param.endDate),
      };
    }

    const { page, list } = await Connection2.requestPost(
      'clinic/pass/queryClinicTestList',
      {
        pageNumber: param.pagination.pageNumber,
        pageSize: param.pagination.pageSize,
        isAscending: param.pagination.isAscending,
        testStatus: param.status === 'all' ? undefined : param.status,
        searchKeyword: param.searchText,
        ...dateRange,
      }
    );
    return {
      page: page,
      list: list.map(testSummaryFromDto),
    };
  };

  // LINK - id 63
  //NOTE - DONE
  getTestById = async (testId: Id): Promise<Test> => {
    const { code, ...res } = await Connection2.requestPost(
      'clinic/pass/queryTestById',
      {
        id: testId,
      }
    );
    return testFromDto(res);
  };

  // LINK - id 70 ???
  //NOTE - NA
  cancelTest = async (testId: number, reason: string): Promise<void> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    await client.mutate({
      mutation: CANCEL_TEST,
      fetchPolicy: 'no-cache',
      variables: {
        input: {
          id: testId,
          reason: reason,
        },
      },
    });
    return;
  };

  //LINK - id 64
  getTestItemSummaries = async (
    searchText: string,
    category: Category
  ): Promise<TestItemSummary[]> => {
    const { list } = await Connection2.requestPost(
      'clinic/pass/queryTestItemListWithFilter',
      {
        searchKeyword: searchText === '' ? undefined : searchText,
        category: category === 'TEST_ALL' ? '' : category,
        pageSize: 9999,
      }
    );
    return list;
  };

  //LINK NEW - id 64
  getTestItemSummariesList = async (
    searchText: string,
    category: Category,
    pagination: Pagination
  ): Promise<TestItemSummary[]> => {
    const { list } = await Connection2.requestPost(
      'clinic/pass/queryTestItemListWithFilter',
      {
        searchKeyword: searchText === '' ? undefined : searchText,
        category: category === 'TEST_ALL' ? '' : category,
        pagination: pagination,
      }
    );
    return list;
  };

  // LINK - id 69
  // NOTE - Done
  createTest = async (
    clientId: Id,
    testItems: Id[],
    registerClerkId: Id,
    personInChargeId: Id,
    memo: Memo
  ): Promise<Test> => {
    const { code, ...res } = await Connection2.requestPost(
      'clinic/pass/create_order_test',
      {
        patient_id: clientId,
        test_list: testItems.map((item: any) => {
          return { test_serial: item.serial, test_id: item.id };
        }),
        receptionist_id: registerClerkId,
        attending_doctor_id: personInChargeId,
        memo: memo,
      }
    );
    return res;
  };

  // LINK - id 66
  //NOTE - pagination
  //NOTE - res type check
  getTestOngoingSummaries = async (
    status: TestStatusDto[],
    fromDate?: Date,
    endDate?: Date
  ): Promise<TestCountResult[]> => {
    let dateRange: { begin: string; end: string } | undefined;
    if (fromDate && endDate) {
      dateRange = {
        begin: toKRString(fromDate),
        end: toKRString(endDate),
      };
    }
    const res: PageResult<{
      testStatus: TestStatusDto;
    }>[] = await Promise.all(
      status.map((val) => {
        return Connection2.requestPost('clinic/pass/queryClinicTestList', {
          // pagination: DefaultPagination,
          pageNumber: 0,
          pageSize: 20,
          testStatus: val.status,
          ...dateRange,
        });
      })
    );
    return res.map((data, idx) => {
      return {
        testStatus: status[idx],
        totalElements: Number(data.page?.totalElements ?? 0),
      };
    });
  };

  // LINK - id 66
  // NOTE - pagination
  // retrun 404
  getTestDoneSummary = async (
    status: TestStatus,
    fromDate?: Date,
    endDate?: Date
  ): Promise<PageResult<TestSummary>> => {
    let dateRange: { begin: string; end: string } | undefined;
    if (fromDate && endDate) {
      dateRange = {
        begin: toKRString(fromDate),
        end: toKRString(endDate),
      };
    }

    const { list, page } = await Connection2.requestPost(
      'clinic/pass/queryClinicTestList',
      {
        pageNumber: 0,
        pageSize: 5,
        testStatus: status,
        ...dateRange,
      }
    );
    return {
      list: list.map(testSummaryFromDto),
      page: page,
    };
  };

  // LINK - id 65
  // NOTE - pagination
  getTestByPatientID = async (
    patientId: Id,
    pagination: Pagination
  ): Promise<PageResult<TestSummary>> => {
    const { list, page } = await Connection2.requestPost(
      'clinic/pass/queryPatientTestList',
      {
        pageNumber: 0,
        pageSize: 10,
        id: patientId,
      }
    );
    return {
      list: list.map(testSummaryFromDto),
      page: page,
    };
  };

  // API - getResultPDF
  getResultPDF = async (
    testId: Id,
    testLang: lang,
    testPlain: plain
  ): Promise<any> => {
    const pdf = await Connection2.requestPost('clinic/pass/getResultPDF', {
      id: testId,
      lang: testLang,
      plain: testPlain,
    });

    return { test: pdf };
  };
}

export default TestRepository;
